import { gql } from '@apollo/client'

const CREATE_ACTION_GOAL = gql`
  mutation createActionGoal(
    $kind: ActionGoalKind!
    $numberDays: Int!
    $metricKind: ActionGoalMetricKind!
    $metricValue: Float
    $goalText: String
  ) {
    createActionGoal(
      kind: $kind
      numberDays: $numberDays
      metricKind: $metricKind
      metricValue: $metricValue
      goalText: $goalText
    ) {
      id
      kind
      numberDays
      cadence
      status
      startDate
      metricKind
      metricValue
    }
  }
`

export default CREATE_ACTION_GOAL
